import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid } from 'react-bootstrap';
import axios from 'axios';
import qs from 'qs';

import Loader from '../../components/Loaders/Loader';
import FilterGroup from '../../components/Filters/FilterGroup';
import SearchGroup from '../../components/Search/SearchGroup';
import Tabs from '../../components/Tabs';
import Table from './components/Table';
import ModalsManager from './components/Modals/Manager';

import { getNavbarCountersAction } from '../../redux/actions/header';
import { getConfig, getList, cancelChildPanel } from '../../services/endpoints/child-panels';
import { WebsocketContext } from '../../utils/WebsocketProvider';

const ChildPanels = () => {
  const { eventData } = useContext(WebsocketContext);

  const dispatch = useDispatch();
  const location = useLocation();

  const queryString = qs.parse(location.search.slice(1));

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [config, setConfig] = useState({});
  const [isLoading, setIsLoading] = useState({ page: true, table: false, modalSubmit: false });
  const [openModal, setOpenModal] = useState('');
  const [modalData, setModalData] = useState({});

  const onHideModals = () => {
    setOpenModal('');
  };

  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, table: true }));

    try {
      const response = await getList(queryString);
      if (response.success) {
        setData(response.data);
      }
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return response.data;
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return error;
    }
  };

  const fetchConfig = async () => {
    try {
      const response = await getConfig(queryString);
      if (response.success) {
        setConfig(response.data);
        return response.data;
      }
    } catch (error) {
      return error;
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      await fetchConfig();
      await fetchList();
      setIsLoading((prevState) => ({ ...prevState, page: false }));
      setInit(true);
    } catch (error) {
      if (axios.isCancel(error)) {
        return;
      }
      setInit(true);
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  };

  const onCancelChildPanel = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await cancelChildPanel(modalData.item.id);
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      onHideModals('');
      fetchList();
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      onHideModals('');
    }
  };

  const onSubmitModal = () => {
    switch (modalData.actionKey) {
    case 1:
      onCancelChildPanel();
      break;

    default:
      break;
    }
  };

  useEffect(() => {
    dispatch(getNavbarCountersAction({ code: 'child-panels-list' }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAllData();

    document.title = 'Child panels';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    switch (eventData?.name) {
    case 'menu_counter_update':
      if (eventData?.options?.code === 'child-panels-list') {
        fetchList();
      }
      break;

    default:
      break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData]);

  return (
    <Grid className="mb-15">
      <ModalsManager open={openModal} isLoadingSubmit={isLoading.modalSubmit} modalData={modalData} onSubmit={onSubmitModal} onHide={onHideModals} />

      <FilterGroup>
        {config?.statuses && <Tabs tab="status" tabsData={config?.statuses} />}
        {config?.access?.list && (
          <SearchGroup autocomplete="on" sectionName="child-panels" placeholder="Search child panels" filters={data?.filters} disabled={isLoading.page} />
        )}
      </FilterGroup>

      {isLoading && !init ? (
        <Loader />
      ) : (
        <>
          {config?.access?.list && (
            <Table items={data?.items} config={config} isLoading={isLoading.table} setOpenModal={setOpenModal} setModalData={setModalData} />
          )}
        </>
      )}
    </Grid>
  );
};

export default ChildPanels;
